/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {SignalAdminResourceApiBase, SignalAdminResourceModel} from '../../common/controller/signal-admin-resource-api';

export interface LayoutModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class LayoutApiService extends SignalAdminResourceApiBase<LayoutModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'layouts');
  }
}
